import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="bg-charcoal text-cream py-20" data-id="element-111">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-6" data-id="element-114">
            Fang dort an, wo das Problem wirklich beginnt.
          </h2>

          <div className="mb-10 space-y-2 text-lg text-cream/80" data-id="element-115">
            <p className="font-semibold text-accent text-xl" data-id="element-116">
              Luisé Scalp-First Hair Oil – Das 3-Flaschen-Ritual
            </p>
            <p data-id="element-117">
              90 Tage. Kopfhaut zuerst. Fettfrei. Für Konsequenz entwickelt.
            </p>
            <p className="pt-4" data-id="element-118">
              Für Frauen, die den oberflächlichen Ansatz bereits kennen – und
              bereit sind für einen anderen Ausgangspunkt.
            </p>
          </div>

          <a href="https://shopavenso.com/products/eelhoe-haarol" target="_blank" rel="noopener noreferrer" className="inline-block bg-accent hover:bg-accent-light text-charcoal font-ui font-semibold uppercase tracking-wider py-4 px-10 rounded-sm transition-colors duration-300 w-full md:w-auto" data-id="element-119">
            Verfügbarkeit prüfen
          </a>
        </motion.div>
      </div>
    </section>;
}